import React, { useState } from "react";
// ✅ Import your local videos
import video1 from "../assets/customer-reviews/video1.mp4";

const CustomerReviewCards = () => {
  const reviews = [
    {
      video: video1,
      // name: "John Doe",
      review:
        "Advaitha Realtors is amazing! They helped me find our dream plot in no time!",
    },
    // {
    //   video: video1,
    //   name: "Jane Smith",
    //   review: "Very professional and quick. Highly recommend their services.",
    // },
    // {
    //   video: video1,
    //   name: "Michael Lee",
    //   review:
    //     "Fantastic experience from start to finish. I couldn’t be happier.",
    // },
    // {
    //   video: video1,
    //   name: "Emily Davis",
    //   review:
    //     "They made the process so easy. I’m forever grateful for their help.",
    // },
    // {
    //   video: video1,
    //   name: "Alice Brown",
    //   review:
    //     "Great experience! The team was very professional and guided me through every step.",
    // },
    // {
    //   video: video1,
    //   name: "Bob White",
    //   review:
    //     "Amazing customer service! They helped me every step of the way to get my perfect home.",
    // },
  ];

  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  const cardsToShow = 3;

  const handleNext = () => {
    if (currentIndex + cardsToShow < reviews.length) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  const handlePrev = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  return (
    <section
      id="customer-reviews"
      className="py-12 sm:py-20 bg-gray-100 flex justify-center items-center"
    >
      <div className="container mx-auto text-center w-full h-auto relative">
        <h2 className="text-3xl sm:text-4xl font-bold text-primary mb-8">
          Customer Reviews
        </h2>

        <div className="flex flex-wrap justify-center items-center gap-6">
          {reviews
            .slice(currentIndex, currentIndex + cardsToShow)
            .map((review, index) => (
              <div
                key={index}
                onMouseEnter={() => setHoveredIndex(index)}
                onMouseLeave={() => setHoveredIndex(null)}
                className={`review-card transform transition-all duration-500 hover:scale-105 hover:opacity-100 ${
                  hoveredIndex === index
                    ? "opacity-100 scale-105"
                    : "opacity-50 scale-95"
                }`}
                style={{
                  width: "100%",
                  maxWidth: "400px",
                  height: "500px",
                  transition: "opacity 0.5s ease, transform 0.5s ease",
                  cursor: "pointer",
                }}
              >
                <video
                  src={review.video}
                  className="w-full h-3/5 object-cover rounded-lg"
                  controls
                  muted
                  playsInline
                />
                <h3 className="text-secondary text-xl sm:text-2xl font-semibold mt-4">
                  {review.name}
                </h3>
                <p className="text-gray-600 mt-2">{review.review}</p>
              </div>
            ))}
        </div>

        {/* Navigation Buttons */}
        <div className="absolute bottom-8 left-0 right-0 flex justify-center gap-4">
          <button
            onClick={handlePrev}
            className="bg-primary text-white p-3 rounded-full shadow-lg hover:shadow-xl transform hover:scale-110 transition duration-300"
            disabled={currentIndex === 0}
          >
            &#10094;
          </button>

          <button
            onClick={handleNext}
            className="bg-primary text-white p-3 rounded-full shadow-lg hover:shadow-xl transform hover:scale-110 transition duration-300"
            disabled={currentIndex + cardsToShow >= reviews.length}
          >
            &#10095;
          </button>
        </div>
      </div>
    </section>
  );
};

export default CustomerReviewCards;
